import {
  CASAMAPA_ADMIN_PORTAL_BASE,
  clientAdminPortalPath,
} from "./clientAdminPortalRoutes.js";

export { CASAMAPA_ADMIN_PORTAL_BASE };

export function casamapaAdminPortalPath(segment = "") {
  return clientAdminPortalPath(CASAMAPA_ADMIN_PORTAL_BASE, segment);
}
